<template v-if="date && availableDates">

    <div class="pm-available-date-picker">
        <a
            href="#"
            :class="{disabled: currentIndex === 0 }"
            @click.prevent="navigate(-1)"
            class="previous"><i class="entypo-chevron-left"></i></a>
        <ui-dropdown v-model="currentValue" :options="availableDatesOptions"/>
        <a
            href="#"
            :class="{disabled: currentIndex === availableDatesOptions.length - 1 }"
            @click.prevent="navigate(1)"
            class="next"><i class="entypo-chevron-right"></i></a>
    </div>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import dateFilter from 'js-core/js/filters/date';

@Component({
    name: 'AvailableDatePicker',
    props: {
        date: String,
        availableDates: Array
    }
})
export default class AvailableDatePicker extends Vue {

    currentValue = null;
    currentIndex = null;

    mounted(){

        this.currentValue = this.date;
        this.currentIndex =  this.availableDatesOptions.findIndex(option => option.value === this.currentValue);

        this.$watch('date', () => {

            this.currentValue = this.date;
            this.currentIndex =  this.availableDatesOptions.findIndex(option => option.value === this.currentValue);
        });

        this.$watch('currentValue', () => {

            this.$emit('update:date', this.currentValue);
        });
    }

    navigate(direction) {

        const currentIndex = this.availableDatesOptions.findIndex(option => option.value === this.currentValue);
        if (currentIndex === -1) return;

        const newIndex = currentIndex + direction;

        if (newIndex >= 0 && newIndex < this.availableDatesOptions.length) {

            this.currentValue = this.availableDatesOptions[newIndex].value;
            this.currentIndex = newIndex;

            this.$emit('update:date', this.availableDatesOptions[newIndex].value);
        }
    }

    get availableDatesOptions() {

        return this.availableDates
            .sort((a, b) => new Date(a) - new Date(b))
            .map(date => ({
                label: dateFilter(date,'D MMM YYYY'),
                value: date
            }));
    }
}
</script>